var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("filter.heading")))]),
      _vm._v(" "),
      _vm.useTabs
        ? [
            _vm.tabs.length > 1
              ? _c(
                  "ul",
                  { staticClass: "nav nav-tabs" },
                  _vm._l(_vm.tabs, function (tab) {
                    return _c(
                      "li",
                      {
                        key: tab.tabname,
                        class: { active: _vm.activeTab === tab.tabname },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.activeTab = tab.tabname
                          },
                        },
                      },
                      [
                        _c("a", { attrs: { href: "#" + tab.tabname } }, [
                          _vm._v(
                            "\n\t\t\t\t" + _vm._s(tab.tabname) + "\n\t\t\t\t"
                          ),
                          _vm.activeFiltersMap[tab.tabname]
                            ? _c(
                                "span",
                                {
                                  staticClass: "badge",
                                  staticStyle: {
                                    "background-color": "#aaa",
                                    "vertical-align": "baseline",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.activeFiltersMap[tab.tabname]
                                      ) +
                                      "\n\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content" },
              _vm._l(_vm.tabs, function (tab, i) {
                return _c(
                  "div",
                  {
                    key: tab.tabname,
                    class: [
                      "tab-pane",
                      "form-horizontal",
                      "filter-container",
                      { active: _vm.activeTab === tab.tabname },
                    ],
                    attrs: { id: tab.tabname },
                  },
                  [
                    _vm._l(tab.subtabs, function (subtab, j) {
                      return [
                        subtab.tabname
                          ? _c("h3", { key: j + subtab.tabname }, [
                              _vm._v(_vm._s(subtab.tabname)),
                            ])
                          : j !== 0
                          ? _c("hr", { key: j })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(subtab.fields, function (id) {
                          return _c(_vm.filterMap[id].componentName, {
                            key: tab.tabname + id,
                            tag: "Component",
                            attrs: {
                              htmlId:
                                i +
                                (j +
                                  id) /* brackets or else i+j collapses before stringifying */,
                              definition: _vm.filterMap[id],
                              textDirection: _vm.textDirection,
                              showLabel:
                                subtab.fields.length > 1 || !subtab.tabname,
                              value:
                                _vm.filterMap[id].value != null
                                  ? _vm.filterMap[id].value
                                  : undefined,
                            },
                            on: {
                              "change-value": function ($event) {
                                return _vm.updateFilterValue(id, $event)
                              },
                            },
                          })
                        }),
                      ]
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        : _vm.allFilters.length
        ? _c(
            "div",
            { staticClass: "tab-content form-horizontal filter-container" },
            _vm._l(_vm.allFilters, function (filter) {
              return _c(filter.componentName, {
                key: filter.id,
                tag: "Component",
                attrs: {
                  htmlId: `filter_${filter.id}`,
                  definition: filter,
                  textDirection: _vm.textDirection,
                  value: filter.value != null ? filter.value : undefined,
                },
                on: {
                  "change-value": function ($event) {
                    return _vm.updateFilterValue(filter.id, $event)
                  },
                },
              })
            }),
            1
          )
        : _c("div", { staticClass: "text-muted well" }, [
            _c("h4", [_vm._v(_vm._s(_vm.$t("filter.noFilter.title")))]),
            _vm._v(" "),
            _c("em", [_vm._v(_vm._s(_vm.$t("filter.noFilter.content")))]),
          ]),
      _vm._v(" "),
      _c("FilterOverview"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }